import React from "react";
import { Mail } from "lucide-react";
import PageHero from "../components/PageHero";
import Reveal from "../components/Reveal";
import CtaSection from "../components/CtaSection";

const TEAM = [
  {
    name: "Siri Algeroy",
    role: "Chief Executive Officer",
    email: "siri@emivia-limited.com",
    bio:
      "Founder & CEO of EMIVIA LIMITED. Over two decades of experience advising high-net-worth individuals, families and institutional investors across the UK and international markets.",
  },
  {
    name: "Alexandre Rochat",
    role: "Chief Financial Officer",
    email: "alexandre@emivia-limited.com",
    bio:
      "Oversees the financial strategy, treasury and reporting functions of EMIVIA. Combines deep expertise in corporate finance with rigorous fiduciary discipline.",
  },
  {
    name: "Davit Manukyan",
    role: "Chief Strategy Officer",
    email: "davit@emivia-limited.com",
    bio:
      "Drives strategic direction, market positioning and growth initiatives. Specialises in long-term value creation across private investment and alternative assets.",
  },
  {
    name: "Richard Moncada",
    role: "Consultant",
    email: "richard@emivia-limited.com",
    bio:
      "Senior consultant advising clients on portfolio construction, asset allocation and bespoke investment opportunities across traditional and digital asset classes.",
  },
  {
    name: "Anthony Rochat",
    role: "Consultant Advisor",
    email: "anthony@emivia-limited.com",
    bio:
      "Trusted advisor delivering strategic counsel on complex investment mandates, succession planning and confidential structuring for our most demanding clients.",
  },
  {
    name: "Emeric Vanhaeren",
    role: "Senior Consultant",
    email: "emeric@emivia-limited.com",
    bio:
      "Senior consultant with broad experience across private investment, structured finance and cross-border transactions. Supports clients through sophisticated advisory mandates and bespoke deal execution.",
  },
];

export default function TeamPage() {
  return (
    <div data-testid="team-page" className="page-fade">
      <PageHero
        eyebrow="Our Leadership"
        title={<>The People <span className="italic">Behind</span> EMIVIA.</>}
        lede="A team of senior professionals combining decades of experience in private investment, wealth management and capital markets."
        image="https://images.pexels.com/photos/8082233/pexels-photo-8082233.jpeg"
        testId="team-hero"
      />

      <section className="bg-[#070B14] py-24 sm:py-32 border-t border-white/5">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5 border border-white/5">
            {TEAM.map((m, i) => (
              <Reveal
                key={m.name}
                delay={i * 100}
                className="group bg-[#070B14] hover:bg-[#0F1523] transition-colors duration-500 p-10 sm:p-14 flex flex-col"
              >
                <div className="text-[11px] uppercase tracking-[0.32em] text-[#D4AF37]">{m.role}</div>
                <h3 className="mt-4 font-serif-display text-white text-3xl sm:text-4xl tracking-tight">
                  {m.name}
                </h3>
                <div className="mt-6 w-12 h-px bg-[#D4AF37]/60" />
                <p className="mt-6 text-white/65 text-sm sm:text-base leading-relaxed font-light max-w-lg flex-1">
                  {m.bio}
                </p>
                <div className="mt-8">
                  <a
                    href={`mailto:${m.email}`}
                    aria-label={`Email ${m.name}`}
                    className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.22em] text-white/70 hover:text-[#D4AF37] transition-colors break-all"
                  >
                    <Mail size={14} strokeWidth={1.5} className="shrink-0 text-[#D4AF37]" />
                    {m.email}
                  </a>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* Values block */}
      <section className="bg-[#0B1120] border-y border-white/5 py-24 sm:py-32">
        <div className="max-w-5xl mx-auto px-5 sm:px-8 lg:px-12 text-center">
          <Reveal>
            <div className="text-[11px] tracking-[0.32em] uppercase text-[#D4AF37]">Independence · Integrity · Discretion</div>
          </Reveal>
          <Reveal delay={120}>
            <h2 className="mt-6 font-serif-display text-white text-4xl sm:text-5xl tracking-tight leading-tight">
              A senior team, <span className="italic">trusted</span> by demanding clients.
            </h2>
          </Reveal>
          <Reveal delay={240}>
            <p className="mt-8 max-w-2xl mx-auto text-white/65 text-base sm:text-lg leading-relaxed font-light">
              Our professionals are united by a long-term investment philosophy, an
              uncompromising commitment to confidentiality, and a track record of delivering
              measurable value to families, entrepreneurs and institutions.
            </p>
          </Reveal>
        </div>
      </section>

      <CtaSection
        testId="team-cta"
        eyebrow="Get in touch"
        title="Speak directly with our leadership."
        description="For confidential introductions, partnership enquiries or mandate discussions, our team is available on request."
      />
    </div>
  );
}
